module.exports = __webpack_public_path__ + "static/media/fireIcon.1bf66071.svg";